export default __webpack_public_path__ + "080b072a79ad0d82f52992cd7d2570d2.ico";